var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.idStr,staticClass:"panel login_box",class:_vm.idStr},[_c('div',{staticClass:"panel_body"},[_c('ul',[_vm._l((_vm.dataList2),function(item,index){return [_c('li',{key:index,staticClass:"item login_box-item",class:{
            animate__backInRight: !index,
            animate__backInLeft: !!index,
          }},[_c('div',{staticClass:"btn",domProps:{"innerHTML":_vm._s(item.label)},on:{"click":function($event){$event.stopPropagation();return item.fun.apply(null, arguments)}}})])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }